import {
    open,
    closeAll
} from '../utils/helpers';

export default (editor, pfx) => {
    const $ = editor.$;
    const bm = editor.Blocks;
    let primaryEl = '';
    ['Embed', 'Clips/VOD\'s' /*, ['Auto-Backup'],
        ['Live Notifications'],
        ['Emotes'], 'Auto-Host', 'Chat', 'Need Designs?'*/
    ].forEach(filter => {
        primaryEl += `<div data-filter="${filter}">
            ${typeof filter === 'string' ? filter : `${filter[0]} <i class="fa fa-lock"></i>`}
        </div>`
    });
    const twitchEl = $(`<div id="${pfx}pn-settings-container" class="${pfx}fadein">
        <div id="${pfx}pn-twitch-primary">${primaryEl}</div>
        <div class="${pfx}pn-content">
            <div class="${pfx}pn-content-header" data-category="Embed"></div>
        </div>
    </div>`);
    const primaryFiltersObject = twitchEl.find(`#${pfx}pn-twitch-primary div`);
    const content = twitchEl.find(`.${pfx}pn-content`);

    primaryFiltersObject.get(0).setAttribute('data-active', true);
    filterTwitchBlocks('Embed', bm, content);
    editor.on('load', () => filterTwitchBlocks('Embed', bm, content));

    primaryFiltersObject.on('click', function (e) {
        if (this.getAttribute('data-active') !== 'true') {
            const query = this.getAttribute('data-filter');
            content.children().get(1) && content.children().get(1).remove(); // empty the panel
            filterTwitchBlocks(query, bm, content);
            closeAll(primaryFiltersObject);
            open(this);
            content.children().get(0).setAttribute('data-category', query);
        }
    });

    return twitchEl;
}

const filterTwitchBlocks = (query, bm, content) => {
    const filtered = bm.getAll().filter(block => {
        if (query === 'Embed')
            return !block.get('category-secondary') && block.get('category-primary') === 'Twitch';
        else {
            const sec = block.get('category-secondary');
            const regExp = sec ? new RegExp(sec) : '';
            return regExp && regExp.test(query);
        }
    });
    content.append(bm.render(filtered, {
        external: true
    }));
}